import { render } from "./AppBarUserMenu.vue?vue&type=template&id=5fa7d5dd&scoped=true"
import script from "./AppBarUserMenu.vue?vue&type=script&lang=js"
export * from "./AppBarUserMenu.vue?vue&type=script&lang=js"

import "./AppBarUserMenu.vue?vue&type=style&index=0&id=5fa7d5dd&scoped=true&lang=css"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa7d5dd"]])

export default __exports__